import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/marketing-attribution')({ staticData: { team: 'analytics' } });
